module.exports = __webpack_public_path__ + "static/media/notepad.a3c247d0.svg";